var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiRsUser1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54_1960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 20.0005H15.8333V15.798C15.8327 15.1447 15.5728 14.5183 15.1109 14.0563C14.6489 13.5943 14.0225 13.3345 13.3692 13.3338H6.63083C5.9775 13.3345 5.35111 13.5943 4.88914 14.0563C4.42716 14.5183 4.16733 15.1447 4.16667 15.798V20.0005H2.5V15.798C2.50132 14.7029 2.93696 13.6529 3.71135 12.8785C4.48575 12.1041 5.53567 11.6685 6.63083 11.6672H13.3692C14.4643 11.6685 15.5143 12.1041 16.2886 12.8785C17.063 13.6529 17.4987 14.7029 17.5 15.798V20.0005Z",
    fill: "#E6B022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 9.99994C9.0111 9.99994 8.0444 9.7067 7.22215 9.15729C6.39991 8.60788 5.75904 7.82699 5.3806 6.91336C5.00217 5.99973 4.90315 4.99439 5.09608 4.02449C5.289 3.05458 5.76521 2.16367 6.46447 1.46441C7.16373 0.765145 8.05465 0.288941 9.02455 0.0960148C9.99446 -0.0969113 10.9998 0.00210539 11.9134 0.380544C12.8271 0.758982 13.6079 1.39984 14.1574 2.22209C14.7068 3.04434 15 4.01103 15 4.99994C14.9987 6.32562 14.4715 7.59662 13.5341 8.53401C12.5967 9.47141 11.3257 9.99862 10 9.99994ZM10 1.66661C9.34073 1.66661 8.69627 1.8621 8.1481 2.22838C7.59994 2.59465 7.1727 3.11524 6.9204 3.72433C6.66811 4.33342 6.6021 5.00364 6.73072 5.65024C6.85934 6.29685 7.1768 6.89079 7.64298 7.35696C8.10915 7.82314 8.7031 8.14061 9.3497 8.26923C9.9963 8.39784 10.6665 8.33183 11.2756 8.07954C11.8847 7.82725 12.4053 7.40001 12.7716 6.85184C13.1378 6.30368 13.3333 5.65921 13.3333 4.99994C13.3333 4.11589 12.9821 3.26804 12.357 2.64292C11.7319 2.0178 10.8841 1.66661 10 1.66661Z",
    fill: "#E6B022"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54_1960"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRsUser1);
export default __webpack_public_path__ + "static/media/fi-rs-user-1.6da153efb851b22c5bd25b0f67986f06.svg";
export { ForwardRef as ReactComponent };